export class Media {
    constructor() {
        this._mediaAddress = 0;
        this.type = 'Media';
    }
    static fromAdress(adress) {
        const media = new Media();
        media.mediaAddress = adress;
        return media;
    }
    static fromContent(content) {
        const media = new Media();
        media.mediaAddress = Media.engine.mediaList.length;
        Media.engine.mediaList.push(content);
        return media;
    }
    set mediaAddress(adress) {
        this._mediaAddress = adress;
    }
    getContent() {
        return Media.engine.mediaList[this._mediaAddress];
    }
    duplicate() {
        return Media.fromAdress(this._mediaAddress);
    }
    static hydrate(data) {
        return Media.fromAdress(data._mediaAddress);
    }
}
